import React, { useState } from 'react';
import ModalComponent from 'molecules/Modal';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { ButtonComp } from 'atoms/Buttons';
import PropTypes from 'prop-types';
import clearIconDark from 'styles/staticAssets/images/clearIconDark.svg';
import ORDER_HISTORY from '../Constants/Constants';

const EditOccasionModalComponent = props => {
  const {
    isOpen,
    handleClose,
    occasionName,
    onSaveOccassion,
    onChangeOccasionName,
    occasionNameResponse,
    handleClearEditInput,
  } = props;
  const [showError, setShowError] = useState(false);
  const {
    CANCEL,
    SAVE,
    EDIT_OCCASSION_DIALOG_TITLE,
    OCCASSION_LABEL,
    SAME_OCCASSIONNAME_ERROR,
    EMPTY_OCCASSION_FIELD_ERROR,
  } = ORDER_HISTORY;

  const handleCloseEditModal = () => {
    handleClose();
    setShowError(false);
  };

  return (
    <React.Fragment>
      {isOpen && (
        <ModalComponent
          show={isOpen}
          showCloseBtn={true}
          closeButtonHandler={handleCloseEditModal}
          classNames='edit-occasion-modal'
          autoFocus={true}
        >
          <h1>{translateWithI18Next(EDIT_OCCASSION_DIALOG_TITLE)}</h1>
          <div className='edit-occassion-input-container'>
            <label for='occasion-name'>{translateWithI18Next(OCCASSION_LABEL)}</label>
            <input
              type='text'
              id='occasion-name'
              data-testid='occasion-input'
              name='occasion-name'
              value={occasionName}
              onChange={e => {
                onChangeOccasionName(e);
                setShowError(true);
              }}
            />
            <img
              src={clearIconDark}
              alt='Clear Icon'
              className='edit-input-clear-icon'
              onClick={handleClearEditInput}
            />
          </div>
          {showError && occasionName === occasionNameResponse && (
            <div className='errorMessageEditOccasion'>{translateWithI18Next(SAME_OCCASSIONNAME_ERROR)}</div>
          )}
          {occasionName.length === 0 && (
            <div className='errorMessageEditOccasion'>{translateWithI18Next(EMPTY_OCCASSION_FIELD_ERROR)}</div>
          )}
          <div className='buttonItems'>
            <ButtonComp
              data-testid='occasion-cancel-button'
              className='button whiteButton blackBorder closebtn-cls'
              onClick={handleClose}
            >
              {translateWithI18Next(CANCEL)}
            </ButtonComp>
            <ButtonComp
              data-testid='submit-button'
              className='button blackButton blackBorder save-button'
              disabled={occasionName === occasionNameResponse || occasionName.length === 0}
              onClick={onSaveOccassion}
            >
              {translateWithI18Next(SAVE)}
            </ButtonComp>
          </div>
        </ModalComponent>
      )}
    </React.Fragment>
  );
};

EditOccasionModalComponent.propTypes = {
  isOpen: PropTypes.bool,
};

EditOccasionModalComponent.defaultProps = {
  isOpen: false,
};

export default EditOccasionModalComponent;
